import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const postApproverHideColumnsAPI = createApi("PostApproverHideColumns","POST");

const PostApproverHideColumns = createSlice({
  name: 'PostApproverHideColumns',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postApproverHideColumnsAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postApproverHideColumnsAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postApproverHideColumnsAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PostApproverHideColumns.reducer;